//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { MembershipCurrencyDisplayItem } from './MembershipCurrencyDisplayItem';
import { CreditCardMetaData } from './CreditCardMetaData';
import { MembershipSubscriptionStatus } from './Enums';

export class SchoolMembershipDisplayItem extends ItemBase {
    Currency: MembershipCurrencyDisplayItem | null = null;
    PlanID: string | null = null;
    MaximumNumberOfTeachers: number = 0;
    ShowAnnualPlans: boolean = false;
    SubscriptionStatus: MembershipSubscriptionStatus = MembershipSubscriptionStatus.Active;
    DaysUntilCreditCardExpires: number | null = null;
    DaysUntilTrialExpires: number | null = null;
    DaysSinceTrialExpired: number | null = null;
    MembershipCreditCardsMetaData: CreditCardMetaData[] = [];

    constructor(initializer?: Partial<SchoolMembershipDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolMembershipDisplayItem";
}
